import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import OfflinePage from "../OfflinePage/OfflinePage";
import { PACKSLIP_CTA_TYPE } from "../../constants";
import PSPrinterModal from "../../components/PackSlip/PSPrinterModal";
import UserGreeting from "../../components/UserGreeting/UserGreeting";
import TMLoader from "../../components/Loader/Loader";
import { usePackSlipData } from "../../hooks/usePackSlipData";
import PSContainerScan from "../../components/PackSlip/PSContainerScan";
import { PACK_SLIP_SCREENS, ROLES } from "../../constants";
import PSSubmitCTASection from "../../components/PackSlip/PSSubmitCTASection";
import { MedicineList } from "../../components/PackSlip";
import { createContext } from "react";

export const Context = createContext();
const PackSlip = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isPrintModalOpen, setPrintModalOpen] = useState(false);
  const {
    screen,
    containerData,
    psData,
    onSubmitContainer,
    toggleLoading,
    loaders: { statusLoading },
    setPsData,
  } = usePackSlipData({ ...props });
  const medicineList = psData?.pendingMedicineList || [];
  const setMedicineList = (updatedList) => {
    setPsData((prev) => {
      return { ...prev, pendingMedicineList: updatedList };
    });
  };
  useEffect(() => {
    if (
      props.userRole?.filter((k) => k?.roleName === ROLES.TO_PACKER_ROLE)
        ?.length === 0
    ) {
      props.history.push("/Profile");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!props.isOnline) {
    return <OfflinePage />;
  }

  const handlePostSubmitCTA = (CTAtype, data) => {
    switch (CTAtype) {
      case PACKSLIP_CTA_TYPE.BOXFULL:
        setPrintModalOpen(true);
        break;
      case PACKSLIP_CTA_TYPE.SUBMIT:
        setPrintModalOpen(true);
        break;
      default:
        break;
    }
  };

  return (
    <Context.Provider value={{ isLoading, setIsLoading }}>
      {isLoading || statusLoading ? <TMLoader /> : null}
      <UserGreeting />
      <br />

      {screen === PACK_SLIP_SCREENS.ASSIGNED ? (
        <>
          <MedicineList
            medicineList={medicineList}
            setMedicineList={setMedicineList}
            psData={psData}
          />
          <PSSubmitCTASection
            transferOrderId={psData?.transferOrderId}
            destinationBox={psData?.destinationBox}
            sourceBox={psData?.sourceBox}
            handlePostCTA={(CTAtype, data) =>
              handlePostSubmitCTA(CTAtype, data)
            }
            medicineList={medicineList}
          />
          <PSPrinterModal
            boxNumber={psData?.destinationBox}
            isPrintModalOpen={isPrintModalOpen}
            setPrintModalOpen={(value) => setPrintModalOpen(value)}
          />
        </>
      ) : (
        <PSContainerScan
          {...props}
          data={containerData}
          submitCall={onSubmitContainer}
        />
      )}
    </Context.Provider>
  );
};

const mapStateToProps = (state) => ({
  userRole: state.authReducer?.AuthData?.userDTO.role,
  isOnline: state.statusReducer?.isOnline,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(PackSlip);
